import React, { useState, useEffect, useContext } from "react";
import "./XeesterBreadcrumb.scss";

import { useTranslation } from "react-i18next";
import { IconButton } from "@material-ui/core";
import { ToggleButtonGroup, ToggleButton } from "@material-ui/lab";
import { AttachMoney, ClearAll, Deck, Loyalty, LocalAtm } from "@material-ui/icons";

function XeesterBreadcrumb(){

    const [money, setMoney] = useState('real');
    const handleMoney = (event, newAlignment) => {
      setMoney(newAlignment);
    };
  
    const [sessionType, setSessionType] = useState(1);
    const handleSessionType = (event, newSessionType) => {
      setSessionType(newSessionType);
    };
  
    const { t } = useTranslation();
  
    return (
        <div id="breadcrumb">
        <ToggleButtonGroup
          value={money}
          exclusive
          onChange={handleMoney}
          aria-label="text alignment"
        >
          <ToggleButton value="real" aria-label="centered">
            <AttachMoney/>
          </ToggleButton>
          <ToggleButton value="points" aria-label="centered">
            <Loyalty/>
          </ToggleButton>
          <ToggleButton value="fun" aria-label="centered">
            <Deck/>
          </ToggleButton>
        </ToggleButtonGroup>
        <div className="breadcrumb-container">
            <div>Réel / Tournois / IGotTheNutz / Sessions / Liste</div>
            <div>Toutes les données</div>
        </div>

        <ToggleButtonGroup
          value={sessionType}
          exclusive
          onChange={handleSessionType}
          aria-label="Session type"
        >
          <ToggleButton value={1} aria-label="centered">
            <ClearAll/>
          </ToggleButton>
          <ToggleButton value={2} aria-label="centered">
            <LocalAtm/>
          </ToggleButton>
        </ToggleButtonGroup>
        </div>
    )
}
export default XeesterBreadcrumb;
